import { Box, useTheme } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import DashboardMenuItem from "./MenuItem";
import handUp3d from "../../../../../media/images/icons/handUp3d.png";
import menu_truck from "../../../../../media/images/icons/menu_truck.png";
import menu_manage from "../../../../../media/images/icons/menu_manage.png";
import menu_attend from "../../../../../media/images/icons/menu_attend.png";

export default function MenuDashboard() {
  const theme = useTheme();
  return (
    <Box
      sx={{
        position: "absolute",
        // border: "1px solid red",
        bottom: "-60px",
        paddingX: "20px",
        left: 0,
        width: "100%",
        display: "flex",
        alignItems: "center",
        gap: "16px",
      }}
    >
      <DashboardMenuItem
        position="right"
        path="/driver/check-in"
        icon={menu_attend}
        title="اعلام حضور"
      />
      <DashboardMenuItem
        position="center"
        path="/driver/get-freight"
        icon={menu_truck}
        title="دریافت بار"
      />
      <DashboardMenuItem
        position="left"
        path="/driver/manage-freight"
        icon={menu_manage}
        title="مدیریت بار"
      />
    </Box>
  );
}
